import {Bot, MessageSquare, Settings, User, Users} from 'lucide-react'
import type {MenuKey} from '@/lib/constants'

type Props = {activeMenu: MenuKey; onNavigate: (path: string) => void}

const items = [
    {key: 'conversation' as MenuKey, label: '聊天', path: '/conversation/realtime', Icon: MessageSquare},
    {key: 'message' as MenuKey, label: '自动化', path: '/message/auto-reply', Icon: Bot},
    {key: 'contact' as MenuKey, label: '好友', path: '/contact/address-book', Icon: User},
    {key: 'group' as MenuKey, label: '群聊', path: '/group/welcome', Icon: Users},
    {key: 'settings' as MenuKey, label: '设置', path: '/settings/personal', Icon: Settings},
]

export function MobileBottomNav({activeMenu, onNavigate}: Props) {
    return <nav className="mobile-bottom-safe fixed inset-x-0 bottom-0 z-40 flex h-14 items-start justify-around border-t border-hair bg-white/95 pt-1 shadow-[0_-2px_10px_rgba(0,0,0,.06)] backdrop-blur md:hidden">
        {items.map(({key, label, path, Icon}) => <button key={key} type="button" onClick={() => onNavigate(path)} aria-label={label} className={`flex min-w-14 flex-col items-center gap-0.5 py-1 text-[10px] ${activeMenu === key ? 'text-accent' : 'text-muted'}`}>
            <Icon size={21}/><span>{label}</span>
        </button>)}
    </nav>
}
